<template>
  <div>
    <h4 v-if="!$store.state.route.meta.hideSelectText" class="font-weight-bold">
      {{ $t('message.trade.currentVehicleSelectionHeader[0]') }} {{ $t(`message.trade.${displayText}`) }}
      {{ $t('message.trade.currentVehicleSelectionHeader[1]') }}
    </h4>
    <h1 v-if="!vehicleDetailsAreEmpty" class="font-weight-bold my-4" :style="{ fontSize: headerSize + 'px' }">
      {{ vehicleDetails }}
    </h1>
    <br v-if="vehicleDetailsAreEmpty" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CurrentVehicleSelection',
  computed: {
    ...mapGetters(['trade/getVehicleName', 'getRouteName']),
    displayText() {
      switch (this.getRouteName) {
        case `trade-year-${this.baseRoute}`:
        case `acquire-year-${this.baseRoute}`:
          return 'year';
        case `trade-make-${this.baseRoute}`:
        case `acquire-make-${this.baseRoute}`:
          return 'make';
        case `trade-model-${this.baseRoute}`:
        case `acquire-model-${this.baseRoute}`:
          return 'model';
        case `trade-trim-${this.baseRoute}`:
        case `acquire-trim-${this.baseRoute}`:
          return 'trim';
        case `trade-style-${this.baseRoute}`:
        case `acquire-style-${this.baseRoute}`:
          return 'style';
        default:
          return '';
      }
    },
    vehicleDetails() {
      return this['trade/getVehicleName'];
    },
    vehicleDetailsAreEmpty() {
      return !this.vehicleDetails.match(/\S/);
    },
    headerSize() {
      return this.getRouteName === 'mobile-report' ? 22 : 28;
    },
  },
};
</script>

<style lang="scss" scoped></style>
